import { TypographyType } from '@/common/components/base/typography/Typography.type';
import Typography from '../../../../common/components/base/typography/Typography';

export default function CashComponent({
  cashValue,
  rialSize = 10,
  textProps,
}: {
  cashValue: string;
  rialSize?: number;
  textProps?: TypographyType;
}) {
  const numCash = Number(cashValue);
  if (isNaN(numCash)) {
    return <Typography>مقدار نامعتبر</Typography>;
  }

  return (
    <Typography fontSize={18} display="flex" gap={4} {...textProps}>
      <span>{numCash.toLocaleString('en-US')}</span>
      <span style={{ fontSize: rialSize, fontWeight: 'normal' }}>ریال</span>
    </Typography>
  );
}
